import dayjs from 'dayjs'
import { Calendar, dayjsLocalizer } from 'react-big-calendar'

dayjs.locale('es')

/**
 * 
 * @param {calendarLabels}
 * Objeto con las etiquetas de textos del calendario, se admiten los siguientes con su consiguiente valor por defecto:
  { 
    date: 'Date',
    time: 'Time',
    event: 'Event',
    allDay: 'All Day',
    week: 'Week',
    work_week: 'Work Week',
    day: 'Day',
    month: 'Month',
    previous: 'Back',
    next: 'Next',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    today: 'Today',
    agenda: 'Agenda',
    noEventsInRange: 'There are no events in this range.',
    showMore: (total, remainingEvents, events) => `+${total} more`,
  }
 * @returns 
 */

const CustomCalendar = ({
  calendarLabels = {},
  calendarMinWidth = 500,
  components,
  endAccessor = 'end',
  eventPropGetter,
  eventsList = [],
  localizer,
  startAccessor = 'start',
  step = 60,
  timeslots = 4,
}) => {
  const calendarLocalizer = localizer ?? dayjsLocalizer(dayjs)

  return (
    <>
      <Calendar
        components={components}
        endAccessor={endAccessor}
        eventPropGetter={eventPropGetter}
        events={eventsList}
        localizer={localizer ?? calendarLocalizer}
        messages={calendarLabels}
        startAccessor={startAccessor}
        step={step}
        style={{ minHeight: calendarMinWidth }}
        timeslots={timeslots}
      />
    </>
  )
}

export default CustomCalendar
